export const POSITIONS_FOR_INSTRUMENT_QUERY = /* GraphQL */ `
  query PositionsForInstrument($instrument_id: String!) {
    positions_for_instrument(instrument_id: $instrument_id) {
      advisors {
        accounts {
          id
          name
          principal_value
          settled_principal_value
          market_value
          basis_market_value
          gain_loss
          money_manager
        }
        name
        num_accounts
        principal_value
        market_value
        basis_market_value
        gain_loss
      }
    }
  }
`
